import { render, staticRenderFns } from "./StatisticOrder.vue?vue&type=template&id=41f9cc84&scoped=true&"
import script from "./StatisticOrder.vue?vue&type=script&lang=ts&"
export * from "./StatisticOrder.vue?vue&type=script&lang=ts&"
import style0 from "./StatisticOrder.vue?vue&type=style&index=0&id=41f9cc84&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f9cc84",
  null
  
)

export default component.exports